import React from 'react';
import { Flex } from '@osmosis/react-ui/components/Box';
import { P } from '@osmosis/react-ui/components/Text';
import { useQuizContext } from '../../../../context/QuizContext';
import { OrderedResponseData } from '../../../../types/quiz';
import { QuizContainer } from '../../QuizContainer';
import OrderedResponseAnswersList from './OrderedResponseAnswersList';
import { SkipQuizButton } from '../utils';

/**
 * Https://elsevier.atlassian.net/browse/OSMS-684.
 */
const OrderedResponse = () => {
  const { currentItem } = useQuizContext();
  const currentData = currentItem?.data as OrderedResponseData;

  return (
    <QuizContainer>
      <P
        fontSize={16}
        textAlign="justify"
        dangerouslySetInnerHTML={{
          __html: currentData.question,
        }}
      />

      <Flex flexDirection="column">
        <Flex justifyContent="flex-end">
          {currentData.answers.map((_, index) => (
            <P key={index} width={40} textAlign="center" fontSize="14">
              {index + 1}
            </P>
          ))}
        </Flex>
        <OrderedResponseAnswersList />
      </Flex>
      <SkipQuizButton />
    </QuizContainer>
  );
};

export default OrderedResponse;
